import { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../../../config/firebase";

const useHsTermData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "CcpHsTerms"));
      const termsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by TermName alphabetically
      termsData.sort((a, b) => a.TermName.localeCompare(b.TermName));

      setData(termsData);
      setError(null);
    } catch (error) {
      console.error("Error fetching HS terms:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const refreshData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "CcpHsTerms"));
      const termsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by TermName alphabetically
      termsData.sort((a, b) => a.TermName.localeCompare(b.TermName));

      setData(termsData);
      setError(null);
    } catch (error) {
      console.error("Error refreshing HS terms:", error);
      setError(error.message);
    }
  };

  const postData = async (newData) => {
    try {
      const { TermName, StartDate, EndDate } = newData;
      await addDoc(collection(db, "CcpHsTerms"), {
        TermName,
        StartDate,
        EndDate,
      });

      // Refresh the list to show current data
      await refreshData();
    } catch (error) {
      console.error("Error adding HS term:", error);
      throw error;
    }
  };

  const updateData = async (updatedData) => {
    try {
      const { id, TermName, StartDate, EndDate } = updatedData;
      const termRef = doc(db, "CcpHsTerms", id);

      await updateDoc(termRef, {
        TermName,
        StartDate,
        EndDate,
      });

      // Refresh the list to show current data
      await refreshData();
    } catch (error) {
      console.error("Error updating HS term:", error);
      throw error;
    }
  };

  const deleteData = async (termId) => {
    try {
      await deleteDoc(doc(db, "CcpHsTerms", termId));
      // Refresh the list to show current data
      await refreshData();
    } catch (error) {
      console.error("Error deleting HS term:", error);
      throw error;
    }
  };

  return { data, loading, error, postData, updateData, deleteData };
};

export default useHsTermData;
